// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:export {
  primaryColor: #007796;
  errorColor: #d9001b;
  warningColor: #f59a23;
  successColor: #63a103;
  backgroundColor: #272524;
}

label.MuiFormControlLabel-root .MuiSwitch-root {
  padding: 0.5rem;
  width: 3rem;
  height: 2rem;
}
label.MuiFormControlLabel-root .MuiSwitch-root .MuiSwitch-switchBase {
  padding: 0.5rem;
}
label.MuiFormControlLabel-root .MuiSwitch-root .MuiSwitch-track {
  height: 0.5rem;
  width: 2rem;
  margin: 0.25rem 0px;
  opacity: 1;
  background-color: #919191;
}
label.MuiFormControlLabel-root .MuiSwitch-root .MuiSwitch-thumb {
  color: #fff;
  height: 1rem;
  width: 1rem;
  border: 1px solid #919191;
}
label.MuiFormControlLabel-root .MuiSwitch-root .Mui-checked {
  -webkit-transform: translateX(1rem);
  -moz-transform: translateX(1rem);
  -ms-transform: translateX(1rem);
  transform: translateX(1rem);
}
label.MuiFormControlLabel-root .MuiSwitch-root .Mui-checked .MuiSwitch-thumb {
  border: 1px solid #00538a;
}
label.MuiFormControlLabel-root .MuiSwitch-root .Mui-checked + .MuiSwitch-track {
  background-color: #00538a;
}`, "",{"version":3,"sources":["webpack://./src/styles/colors.module.scss","webpack://./src/components/Elements/switchElement.scss"],"names":[],"mappings":"AA2BA;EACE,qBA5Bc;EA6Bd,mBA5BY;EA6BZ,qBA5Bc;EA6Bd,qBA5Bc;EA6Bd,wBA5BiB;ACEnB;;AAHE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAMJ;AAJI;EACE,eAAA;AAMN;AAHI;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,yBDHO;ACQb;AAFI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAIN;AADI;EACE,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,2BAAA;AAGN;AADM;EACE,yBAAA;AAGR;AAAM;EACE,yBDhC4B;ACkCpC","sourcesContent":["$primary-color: #007796;\n$error-color: #d9001b;\n$warning-color: #f59a23;\n$success-color: #63a103;\n$background-color: #272524;\n$background-color-opacity: rgba(29, 26, 25, 0.85);\n$button-contained-background-color: #00538a;\n$button-contained-text-color: #fff;\n$button-contained-border-color: #00538a;\n\n$button-outlined-background-color: #363433;\n$button-outlined-text-color: #fff;\n$button-outlined-border-color: #363433;\n\n$icon-color: #919191;\n$svg-color: #cdcccc;\n$badge-color: #e04545;\n\n$input-background-color: #1d1a19;\n$table-odd-row-background-color: #1d1a19;\n\n$text-color: #d7d6d6;\n$text-color-light: #282929;\n$link-color: #02a4ff;\n$border-color: #1d1a19;\n\n\n:export {\n  primaryColor: $primary-color;\n  errorColor: $error-color;\n  warningColor: $warning-color;\n  successColor: $success-color;\n  backgroundColor: $background-color;\n}","@use \"../../styles/colors.module.scss\" as *;\n\nlabel.MuiFormControlLabel-root {\n  .MuiSwitch-root {\n    padding: .5rem;\n    width: 3rem;\n    height: 2rem;\n\n    .MuiSwitch-switchBase {\n      padding: .5rem;\n    }\n\n    .MuiSwitch-track {\n      height: .5rem;\n      width: 2rem;\n      margin: .25rem 0px;\n      opacity: 1;\n      background-color: $icon-color;\n    }\n\n    .MuiSwitch-thumb {\n      color: #fff;\n      height: 1rem;\n      width: 1rem;\n      border: 1px solid $icon-color;\n    }\n\n    .Mui-checked {\n      -webkit-transform: translateX(1rem);\n      -moz-transform: translateX(1rem);\n      -ms-transform: translateX(1rem);\n      transform: translateX(1rem);\n\n      .MuiSwitch-thumb {\n        border: 1px solid $button-contained-background-color;\n      }\n\n      &+.MuiSwitch-track {\n        background-color: $button-contained-background-color;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
